









































































import {Component, Vue} from 'vue-property-decorator';
import PageLoader from '@/components/page-loader/page-loader.vue';
import ReportVueContainer from '@/modules/neodash/components/report-vue-container/report-vue-container.vue';
import FilterContainer from '@/modules/neodash/components/filter-container/filter-container.vue';
import FilterDropDown from '@/modules/neodash/components/filter-form/filter-drop-down/filterDropDown.vue';
import KendoDropdown from '@/components/kendo-dropdown/kendo-dropdown.vue';
import ReportContainer from '@/modules/neodash/components/report-container/report-container.vue';

import {i18nMixin} from '@/modules/neodash/mixins';
import * as _ from 'lodash';

import TableMonthlyGoalRegistration
  from '@/modules/business-plan/modules/report/table-monthly-goal-registration.page.vue';
import TableChartGoalRegistration
  from '@/modules/business-plan/modules/report/table-chart-goal-registration.page.vue';
import {ApprovalService} from '@/modules/business-plan/modules/services/approval.service';
import {
  IData,
  IGoalVsRegistration,
  IGoalVsRegistrationData,
  OrderGroupEnum
} from '@/modules/business-plan/modules/report/types';
import {Families} from '@/modules/business-plan/modules/approval/pages/ford-goal-settings/types';
import {TupleDictionary} from '@/utils/tupleDictionary';
import {GoalVsRegistrationType} from '@/modules/business-plan/modules/models/enums/goalVsRegistrationType';
import {SaleTypeEnum} from '@/enums/sale-type.enum';
import {NameValues, OptionalNameValue} from '@/modules/neodash/model/types/interfaces/NameValue';

export interface IFilter {
  project: OptionalNameValue,
  dealer: OptionalNameValue,
  format: OptionalNameValue,
  dataSource: OptionalNameValue
}

@Component({
  name: 'ToyotaGoalVsRegistrationReport',
  components: {
    FilterDropDown,
    FilterContainer,
    ReportContainer,
    PageLoader,
    ReportVueContainer,
    TableChartGoalRegistration,
    TableMonthlyGoalRegistration,
    KendoDropdown
  }})
export default class ToyotaGoalVsRegistrationReport extends Vue {
  public readonly translate = i18nMixin.methods.i18n;
  public OrderGroupEnum = OrderGroupEnum;
  public families: Families = [];

  public filtersModel = {
    project: null,
    dealer: null,
    format: null,
    dataSource: null
  } as IFilter;
  public storeValue: IGoalVsRegistration = {
    idProject: 0,
    idStoreProject: 0,
    idEconomicGroupProject: 0,
    idStoreUnique: '',
    idStoreClient: '',
    nameStore: '',
    nameEconomicGroup: '',
    city: '',
    state: '',
    values: []
  };
  public formatSelected: string = '';
  public dataSourceSelected: string = '';

  public endMonthRegistration: number;
  public dictData: TupleDictionary<OrderGroupEnum, IData[]> = new TupleDictionary<OrderGroupEnum, IData[]>();
  public currentData: IData[] = [];
  public projectsDataSource: NameValues = [];
  public dealerDataSource: NameValues = [];
  public formatDataSource: NameValues = [
    { name: 'Canal', value: OrderGroupEnum.channel },
    { name: 'Família', value: OrderGroupEnum.family }
  ];

  public dataSourceType: NameValues = [
    { name: 'Emplacamento', value: GoalVsRegistrationType.Registration },
    { name: 'Faturamento', value: GoalVsRegistrationType.Sale },
  ];

  public get yearReference(): number {
    return this.storeValue.values[0].yearReference;
  }

  public get formValid() {
    const {filtersModel} = this;
    let formValid = !(_.isEmpty(filtersModel));

    for (let member in filtersModel) {
      if (!!filtersModel[member] && filtersModel[member].value != 0)
        continue;

      formValid = false;
    }

    return formValid;
  }

  public get labels() {
    const {project, dealer} = this.filtersModel;
    if (!project || !dealer){
      return [];
    }
    const {translate} = this;
    const [labelProject, labelDealer] =
      ['Common.Project', 'Common.Dealer'].map(x => translate(x));

    return [
      {text: labelProject, value: project.name},
      {text: labelDealer, value: dealer.name}
    ]
  }

  public created() {
    const { GetProjects } = ApprovalService;

    Promise.all([GetProjects()])
      .then(([projects]) => {
        this.projectsDataSource = projects;
      });
  }

  public getReport() {
    const {filtersModel} = this;
    if (!filtersModel.project || !filtersModel.dealer || !filtersModel.dataSource || !filtersModel.format)
      return;

    const {GetGoalVsRegistrationReport, GetLastMonthRegistration, ListFamilies} = ApprovalService;
    this.formatSelected = filtersModel.format.name;
    this.dataSourceSelected = filtersModel.dataSource.name;

    Promise.all([
      ListFamilies(filtersModel.project.value),
      GetGoalVsRegistrationReport(filtersModel.project.value, filtersModel.dealer.value, SaleTypeEnum.DirectSales, filtersModel.dataSource.value),
      GetLastMonthRegistration(filtersModel.project.value, SaleTypeEnum.DirectSales)])
      .then(([families, goalVsRegistration, endMonth]) => {
        this.families = families;
        this.storeValue = goalVsRegistration;

        this.dictData.set(OrderGroupEnum.channel, this.getDataChannelStructure());
        this.dictData.set(OrderGroupEnum.family, this.getDataFamilyStructure());

        if(!filtersModel.format)
          return;

        this.currentData = this.dictData.get(filtersModel.format.value);
        this.endMonthRegistration = endMonth;
      });
  }

  public async loadDealersDataSource() {
    const {project} = this.filtersModel;

    if (!project)
      return;

    this.dealerDataSource = await ApprovalService.GetStoreProjects(project.value);
  }

  public getDataFamilyStructure(): IData[] {
    const saleChannels = this.families
      .map(x => x.saleChannels)
      .reduce((result, crrValue) => result.concat(crrValue), [])
      .distinctBy(x => x.value);

    let result = this.families
      .map(x => {
        return {
          id: x.id,
          name: x.name,
          orderGroupEnum: OrderGroupEnum.family,
          values: saleChannels
            .map(x => {
              return {
                id: x.value,
                name: x.text
              }
            }),
          getValue: function (storeValues: IGoalVsRegistrationData[], typeInformation: GoalVsRegistrationType, keyValue?: number, month?: number): number {
            return storeValues
              .filter(x =>
                x.typeInformation === typeInformation
                && x.idFamily === this.id
                && (!keyValue || x.saleChannel === keyValue)
                && (!month || x.monthReference === month))
              .sumBy(x => x.value);
          }
        }
      }) as IData[];

    const ttlValues = {
      id: -1,
      name: 'MODELOS',
      orderGroupEnum: OrderGroupEnum.family,
      values: this.families.map(x => {
        return {
          id: x.id,
          name: x.name
        } as IData
      }),
      getValue: function (storeValues: IGoalVsRegistrationData[], typeInformation: GoalVsRegistrationType, keyValue?: number, month?: number): number {
        return storeValues
          .filter(x =>
            x.typeInformation === typeInformation
            && (!keyValue || x.idFamily ===  keyValue)
            && (!month || x.monthReference === month))
          .sumBy(x => x.value);
      }
    };

    result.unshift(ttlValues);
    return result;
  }

  public getDataChannelStructure(): IData[] {
    const saleChannels = this.families
      .map(x => x.saleChannels)
      .reduce((result, crrValue) => result.concat(crrValue), [])
      .distinctBy(x => x.value);

    let result = saleChannels
      .map(saleChannel => {
        return {
          id: saleChannel.value,
          name: saleChannel.text,
          orderGroupEnum: OrderGroupEnum.channel,
          values: this.families
            //.filter(x => x.saleChannels.some(y => y.value == saleChannel.value || saleChannel.value === -1))
            .distinctBy(x => x.id)
            .map(x => {
              return {
                id: x.id,
                name: x.name
              } as IData
            }),
          getValue: function (storeValues: IGoalVsRegistrationData[], typeInformation: GoalVsRegistrationType, keyValue?: number, month?: number): number {
            return storeValues
              .filter(x =>
                x.typeInformation === typeInformation
                && x.saleChannel === this.id
                && (!keyValue || x.idFamily === keyValue)
                && (!month || x.monthReference === month))
              .sumBy(x => x.value);
          }
        }
      }) as IData[];

    const ttlValues = {
      id: -1,
      name: 'CANAIS',
      orderGroupEnum: OrderGroupEnum.channel,
      values: saleChannels
        .map(x => {
          return {
            id: x.value,
            name: x.text
          } as IData
        }),
      getValue: function (storeValues: IGoalVsRegistrationData[], typeInformation: GoalVsRegistrationType, keyValue?: number, month?: number): number {
        return storeValues
          .filter(x =>
            x.typeInformation === typeInformation
            && (!keyValue || x.saleChannel === keyValue)
            && (!month || x.monthReference === month))
          .sumBy(x => x.value);
      }
    };

    result.unshift(ttlValues);
    return result;
  }
}
